module.exports = __webpack_public_path__ + "static/media/about-people-colored.cb21d1e8.png";